import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalStore, ModalContext } from '../../../components/contexts';
import ValidateService from '../../../services/ValidateService';
import ResVideoFrameController from '../../../controllers/aia/ResVideoFrameController';

const ConsultVideoFrame = ({ param }) => {
  const [pageParam, setPageParam] = useState({ ...param });
  useEffect(() => {
    document.title = 'AI영상분석결과 - 프레임별';
  }, []);

  const contentRef = useRef(null);

  const location = useLocation();

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const naviagte = useNavigate();

  const [lblList, setLblList] = useState([]);
  const [selectedLbl, setSelectedLbl] = useState('');
  const [searchCondition, setSearchCondition] = useState('');
  const [frameList, setFrameList] = useState([]);
  const [selectedFrame, setSelectedFrame] = useState('');
  const [dataList, setDataList] = useState([]);
  const [selectedData, setSelectedData] = useState([]);

  const controller = useMemo(() => {
    return new ResVideoFrameController(
      { store, updateStore },
      { pageParam, setPageParam },
      { lblList, setLblList },
      { selectedLbl, setSelectedLbl },
      { searchCondition, setSearchCondition },
      { frameList, setFrameList },
      { selectedFrame, setSelectedFrame },
      { dataList, setDataList },
      { selectedData, setSelectedData },
      modalService,
      validateService,
      naviagte
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    const tempSelect1 = dataList.filter(data => data.frameNo === selectedFrame);
    const tempLbl = tempSelect1.map(item => ({ lbl: item.anlsTrprLbl }));
    setLblList(tempLbl);

    const tempSelect2 = tempSelect1.filter(
      data => data.anlsTrprLbl === tempLbl[0].lbl
    )[0];

    setSelectedData(tempSelect2);
  }, [selectedFrame]);

  useEffect(() => {
    setSelectedLbl(lblList[0]?.lbl);
  }, [lblList]);

  useEffect(() => {
    const tempSelect1 = dataList.filter(data => data.frameNo === selectedFrame);
    const tempSelect2 = tempSelect1.filter(
      data => data.anlsTrprLbl === selectedLbl
    )[0];

    setSelectedData(tempSelect2);
  }, [selectedLbl]);

  useEffect(() => {}, [searchCondition]);

  useEffect(() => {
    if (
      pageParam !== undefined &&
      pageParam !== null &&
      pageParam?.aiaRsltId !== undefined &&
      pageParam?.aiaRsltId !== null &&
      pageParam?.aiaRsltId !== '' &&
      pageParam?.vdoId !== undefined &&
      pageParam?.vdoId !== null &&
      pageParam?.vdoId !== ''
    ) {
      controller.fnSearch();
    }
  }, [pageParam]);

  useEffect(() => {
    setPageParam({
      aiaRsltId: location.state?.aiaRsltId,
      vdoId: location.state?.vdoId,
    });
  }, [location]);

  const ColloredTd = ({ color, text, selected, colspan = 1 }) => {
    return (
      <>
        {selected ? (
          <td colSpan={colspan} style={{ backgroundColor: color }}>
            {text}
          </td>
        ) : (
          <td colSpan={colspan}>{text}</td>
        )}
      </>
    );
  };

  return (
    <>
      <div ref={contentRef}>
        {frameList.length > 0 ? (
          <>
            <div className="tbl-wrap">
              <table className="tbl data row">
                <tbody>
                  <tr>
                    <th scope="row">라벨</th>
                    <td>
                      <div className="input-group">
                        <label
                          className="hidden-label"
                          htmlFor="selected"
                          id="selectedLbl"
                        >
                          라벨
                        </label>
                        <select
                          className="form-select md"
                          id="selected"
                          value={selectedLbl}
                          onChange={e => {
                            controller.lblChange(e.target.value);
                          }}
                          aria-labelledby="selectedLbl"
                        >
                          {lblList.map((lbl, index) => {
                            return (
                              <option key={index} value={lbl.lbl}>
                                {lbl.lbl}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="tbl-wrap">
              <h3 className="block-tit">분석결과 - 이미지별 상세조회</h3>
              <div className="img-wrap">
                <div className="img-item">
                  <div className="img-item">
                    <img
                      src={
                        frameList.filter(
                          frame => frame.frameNo === selectedFrame
                        )[0]?.thmb
                      }
                      alt="Main Display"
                    />
                  </div>
                </div>
                <div className="img-list">
                  <div className="img-list-inner">
                    {frameList.map((img, index) => (
                      <a
                        className={`img-list-item ${
                          img.frameNo === selectedFrame ? 'active' : ''
                        }`}
                        key={index}
                        onClick={e => {
                          e.preventDefault();
                          controller.selectedFrameChange(img.frameNo);
                        }}
                      >
                        <img src={img?.thmb} alt={`Thumbnail ${index + 1}`} />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <table className="tbl row data scroll divide">
                <colgroup>
                  <col style={{ width: '7%' }} />
                  <col style={{ width: '17%' }} />
                  <col style={{ width: '17%' }} />
                  <col style={{ width: '17%' }} />
                  <col style={{ width: '17%' }} />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>-</th>
                    <th colSpan={2}>자세정보</th>
                    <th colSpan={2}>부가정보</th>
                    <th className="bg1">OWAS</th>
                    <th className="bg1">RULA</th>
                    <th className="bg1">REBA</th>
                  </tr>
                  <tr>
                    <th>목</th>
                    <td colSpan={2}>
                      {selectedData?.neckPt === 'NC_PT_01'
                        ? '뒤로 젖힘'
                        : selectedData?.neckPt === 'NC_PT_02'
                        ? '0도 ~ 10도 굽힘'
                        : selectedData?.neckPt === 'NC_PT_03'
                        ? '10도 ~ 20도 굽힘'
                        : selectedData?.neckPt === 'NC_PT_04'
                        ? '20도 이상 굽힘'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.neckTwistedYn === 'Y' ? '비틀림' : '-'}
                    </td>
                    <td>
                      {selectedData?.neckBendedYn === 'Y'
                        ? '옆으로 구부림'
                        : '-'}
                    </td>
                    <td rowSpan={2}>{selectedData?.owasTrunkScr}</td>
                    <td>{selectedData?.rulaNeckScr}</td>
                    <td>{selectedData?.rebaNeckScr}</td>
                  </tr>
                  <tr>
                    <th>몸통</th>
                    <td>
                      {selectedData?.trunkPs === 'TR_PS_01'
                        ? '곧바로 편 자세(서있음)'
                        : selectedData?.trunkPs === 'TR_PS_02'
                        ? '상체를 앞으로 20도 이상 굽힌 자세'
                        : selectedData?.trunkPs === 'TR_PS_03'
                        ? '바로 서서 허리를 옆으로 20도 이상 비튼 자세'
                        : selectedData?.trunkPs === 'TR_PS_04'
                        ? '상체를 앞으로 굽힌 채 옆으로 비튼 자세'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.trunkPt === 'TR_PT_01'
                        ? '-20도 이상 뒤로'
                        : selectedData?.trunkPt === 'TR_PT_02'
                        ? '20도 ~ 0도 뒤로'
                        : selectedData?.trunkPt === 'TR_PT_03'
                        ? '똑바로'
                        : selectedData?.trunkPt === 'TR_PT_04'
                        ? '0~20도 굽힘'
                        : selectedData?.trunkPt === 'TR_PT_05'
                        ? '20도 ~ 60도 굽힘'
                        : selectedData?.trunkPt === 'TR_PT_06'
                        ? '60도 이상 굽힘'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.trunkTwistedYn === 'Y' ? '비틀림' : '-'}
                    </td>
                    <td>
                      {selectedData?.trunkBendedYn === 'Y' ? '구부림' : '-'}
                    </td>

                    <td>{selectedData?.rulaTrunkScr}</td>
                    <td>{selectedData?.rebaTrunkScr}</td>
                  </tr>
                  <tr>
                    <th>다리</th>
                    <td>
                      {selectedData?.legPs === 'LG_PS_01'
                        ? '앉은 자세'
                        : selectedData?.legPs === 'LG_PS_02'
                        ? '두 다리를 펴고 선 자세'
                        : selectedData?.legPs === 'LG_PS_03'
                        ? '한 다리로 선 자세'
                        : selectedData?.legPs === 'LG_PS_04'
                        ? '두 다리를 구부린 선 자세'
                        : selectedData?.legPs === 'LG_PS_05'
                        ? '한 다리로 서서 구부린 선 자세'
                        : selectedData?.legPs === 'LG_PS_06'
                        ? '무릎을 꿇는 자세'
                        : selectedData?.legPs === 'LG_PS_07'
                        ? '걷기'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.legPt === 'LG_PT_01'
                        ? '한 다리로 지지'
                        : selectedData?.legPt === 'LG_PT_02'
                        ? '두 다리로 지지'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.legAg === 'LG_PT_01'
                        ? '무릎이 30~60도 구부러질 경사시(앉은자세 제외)'
                        : selectedData?.legAg === 'LG_PT_02'
                        ? '무릎이 60도 이상 구부러질 시(앉은자세 제외)'
                        : '-'}
                    </td>
                    <td>
                      <div className="inner-list">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name="legSittedSupportedYn"
                            id="chk_5"
                            onClick={e => {
                              controller.loadDataChange(
                                'legSittedSupportedYn',
                                e.target.checked ? 'Y' : 'N'
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.legSittedSupportedYn === 'Y'}
                          />
                          <label htmlFor="chk_5" style={{ textAlign: 'left' }}>
                            <span>앉은 자세(허리 지지됨)</span>
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name="legSittedNotSupportedYn"
                            id="chk_6"
                            onClick={e => {
                              controller.loadDataChange(
                                'legSittedNotSupportedYn',
                                e.target.checked ? 'Y' : 'N'
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={
                              selectedData?.legSittedNotSupportedYn === 'Y'
                            }
                          />
                          <label htmlFor="chk_6" style={{ textAlign: 'left' }}>
                            <span>앉은 자세(허리 지지 않됨)</span>
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>{selectedData?.owasLegScr}</td>
                    <td>{selectedData?.rulaLegScr}</td>
                    <td>{selectedData?.rebaLegScr}</td>
                  </tr>
                  <tr>
                    <th>어깨(상완)</th>
                    <td colSpan={2}>
                      {selectedData?.upperArmPt === 'UA_PT_01'
                        ? '-20도 이상 뒤로'
                        : selectedData?.upperArmPt === 'UA_PT_02'
                        ? '-20도 뒤로 ~ 20도 앞으로'
                        : selectedData?.upperArmPt == 'UA_PT_03'
                        ? '20~45도 앞으로'
                        : selectedData?.upperArmPt == 'UA_PT_04'
                        ? '45~90도 앞으로'
                        : selectedData?.upperArmPt == 'UA_PT_05'
                        ? '90도 이상 위로'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.upperArmAbductedYn === 'N' &&
                      selectedData?.upperArmRaisedYn === 'N'
                        ? '-'
                        : `${
                            selectedData?.upperArmAbductedYn === 'Y'
                              ? '위팔 벌어지거나 회전'
                              : '-'
                          } / ${
                            selectedData?.upperArmRaisedYn === 'Y'
                              ? '어깨들림'
                              : '-'
                          }`}
                    </td>
                    <td>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name="upperArmSupportedYn"
                          id="chk_7"
                          onClick={e => {
                            controller.loadDataChange(
                              'upperArmSupportedYn',
                              e.target.checked ? 'Y' : 'N'
                            );
                          }}
                          disabled
                          className={'readOnly'}
                          checked={selectedData?.upperArmSupportedYn === 'Y'}
                        />
                        <label htmlFor="chk_7" style={{ textAlign: 'left' }}>
                          <span>팔이 지지되거나 몸을 어딘가에 기댐</span>
                        </label>
                      </div>
                    </td>
                    <td rowSpan={4}>{selectedData?.owasArmScr}</td>
                    <td>{selectedData?.rulaUpperArmScr}</td>
                    <td>{selectedData?.rebaUpperArmScr}</td>
                  </tr>
                  <tr>
                    <th>아래팔</th>
                    <td>
                      {selectedData?.lowerArmPs === 'AA_PS_01'
                        ? '양팔 어깨 아래'
                        : selectedData?.lowerArmPs === 'AA_PS_02'
                        ? '한팔 어깨 위'
                        : selectedData?.lowerArmPs === 'AA_PS_03'
                        ? '양팔 어깨 위'
                        : '-'}
                    </td>
                    <td>
                      {selectedData?.lowerArmPt === 'LA_PT_01'
                        ? '0 ~ 60도(위팔 수직선에서)'
                        : selectedData?.lowerArmPt === 'LA_PT_02'
                        ? '60 ~ 100도(위팔 수직선에서)'
                        : selectedData?.lowerArmPt === 'LA_PT_03'
                        ? '100도 이상(위팔 수직선에서)'
                        : '-'}
                    </td>
                    <td colspan={2}>
                      {selectedData?.lowerArmOutBodyYn === 'Y'
                        ? '팔이 교차 또는 몸통을 벗어남'
                        : '-'}
                    </td>
                    <td>{selectedData?.rulaLowerArmScr}</td>
                    <td>{selectedData?.rebaLowerArmScr}</td>
                  </tr>
                  <tr>
                    <th>손목</th>
                    <td rowSpan={2} colSpan={2}>
                      {selectedData?.wristPt === 'WR_PT_01'
                        ? '15도 이상 들림'
                        : selectedData?.wristPt === 'WR_PT_02'
                        ? '중립'
                        : selectedData?.wristPt === 'WR_PT_03'
                        ? '-15도 아래 ~ 15도 사이'
                        : selectedData?.wristPt === 'WR_PT_04'
                        ? '-15도 이상 꺾임'
                        : '-'}
                    </td>
                    <td rowSpan={2}>
                      {selectedData?.wristTwist === 'WR_AJ_01'
                        ? '손목이 중립에서 반정도 비틀어짐'
                        : selectedData?.wristTwist === 'WR_AJ_02'
                        ? '손목이 완전히 비틀어짐'
                        : '-'}
                    </td>
                    <td rowSpan={2}>
                      {selectedData?.wristBendedYn == 'Y'
                        ? '손목이 옆으로 굽혀짐'
                        : '-'}
                    </td>
                    <td>{selectedData?.rulaWristScr}</td>
                    <td rowSpan={2}>{selectedData?.rebaWristScr}</td>
                  </tr>
                  <tr>
                    <th>손목 비틀림</th>
                    <td>{selectedData?.rulaWristScr}</td>
                  </tr>
                </tbody>
              </table>
              <table
                className="tbl data row scroll divide"
                style={{ borderTop: '1px solid #fff' }}
              >
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>무게</th>
                    <th>빈도/강도</th>
                    <th>손잡이</th>
                    <th>추가사항</th>
                  </tr>
                  <tr>
                    <td>
                      <div className="inner-list">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="weight1"
                            name="weight"
                            value="WT_01"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.weight === 'WT_01'}
                          />
                          <label htmlFor="weight1">2kg미만</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="weight2"
                            name="weight"
                            value="WT_02"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.weight === 'WT_02'}
                          />
                          <label htmlFor="weight2">2~5kg</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="weight3"
                            name="weight"
                            value="WT_03"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.weight === 'WT_03'}
                          />
                          <label htmlFor="weight3">5~10kg</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="weight4"
                            name="weight"
                            value="WT_04"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.weight === 'WT_04'}
                          />
                          <label htmlFor="weight4">10~20kg</label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="weight5"
                            name="weight"
                            value="WT_05"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.weight === 'WT_05'}
                          />
                          <label htmlFor="weight5">20kg이상</label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="inner-list">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="freq1"
                            name="freqIntens"
                            value="FQ_01"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.freqIntens === 'FQ_01'}
                          />
                          <label htmlFor="freq1" style={{ textAlign: 'left' }}>
                            가끔 물건을 들어올림
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="freq2"
                            name="freqIntens"
                            value="FQ_02"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.freqIntens === 'FQ_02'}
                          />
                          <label htmlFor="freq2" style={{ textAlign: 'left' }}>
                            정적이거나 반복작업을 수행
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="freq3"
                            name="freqIntens"
                            value="FQ_03"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.freqIntens === 'FQ_03'}
                          />
                          <label htmlFor="freq3" style={{ textAlign: 'left' }}>
                            갑작스럽게 물건을 들어올리거나 충격을 받음
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="inner-list">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="handle1"
                            name="coupling"
                            value="HD_01"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.coupling === 'HD_01'}
                          />
                          <label
                            htmlFor="handle1"
                            style={{ textAlign: 'left' }}
                          >
                            좋음(적절한 손잡이)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="handle2"
                            name="coupling"
                            value="HD_02"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.coupling === 'HD_02'}
                          />
                          <label
                            htmlFor="handle2"
                            style={{ textAlign: 'left' }}
                          >
                            보통(대용 손잡이)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="handle3"
                            name="coupling"
                            value="HD_03"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.coupling === 'HD_03'}
                          />
                          <label
                            htmlFor="handle3"
                            style={{ textAlign: 'left' }}
                          >
                            나쁨(부적절한 손잡이)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="handle4"
                            name="coupling"
                            value="HD_04"
                            onChange={e => {
                              controller.loadDataChange(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.coupling === 'HD_04'}
                          />
                          <label
                            htmlFor="handle4"
                            style={{ textAlign: 'left' }}
                          >
                            부적절(손잡이 없음)
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="inner-list">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name="staticYn"
                            id="chk_1"
                            onClick={e => {
                              controller.loadDataChange(
                                'staticYn',
                                e.target.checked ? 'Y' : 'N'
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.staticYn === 'Y'}
                          />
                          <label htmlFor="chk_1" style={{ textAlign: 'left' }}>
                            <span>1분이상 정적자세</span>
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name="reptYn"
                            id="chk_2"
                            onClick={e => {
                              controller.loadDataChange(
                                'reptYn',
                                e.target.checked ? 'Y' : 'N'
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.reptYn === 'Y'}
                          />
                          <label htmlFor="chk_2" style={{ textAlign: 'left' }}>
                            <span>분당 4회 이상 반복</span>
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name="unstableYn"
                            id="chk_3"
                            onClick={e => {
                              controller.loadDataChange(
                                'unstableYn',
                                e.target.checked ? 'Y' : 'N'
                              );
                            }}
                            disabled
                            className={'readOnly'}
                            checked={selectedData?.unstableYn === 'Y'}
                          />
                          <label htmlFor="chk_3" style={{ textAlign: 'left' }}>
                            <span>
                              동작으로 자세가 급변하거나 불안정한 지지면에서
                              수행됨
                            </span>
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="tbl data row scroll divide">
                <colgroup>
                  <col style={{ width: '75%' }} />
                  <col style={{ width: '9%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th className="bg1">SCORE</th>
                    <td>{selectedData?.owasScr}</td>
                    <td>{selectedData?.rulaScr}</td>
                    <td>{selectedData?.rebaScr}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="tbl-wrap">
              <table className="tbl row data scroll divide">
                <tbody>
                  <tr>
                    <th></th>
                    <th style={{ backgroundColor: '#28a745' }}></th>
                    <th colSpan={2} style={{ backgroundColor: '#fff700' }}></th>
                    <th colSpan={2} style={{ backgroundColor: '#ffa600' }}></th>
                  </tr>
                  <tr>
                    <th>AI분석결과</th>
                    <td>양호</td>
                    <td colSpan={2}>모니터링 필요</td>
                    <td colSpan={3}>유해요인기본조사 및 전분가 분석 필요</td>
                  </tr>
                  <tr>
                    <th className="bg3">OWAS</th>
                    <ColloredTd
                      color="#28a745"
                      colspan="1"
                      text="AC1"
                      selected={selectedData?.owasScrRange === '1'}
                    />
                    <ColloredTd
                      color="#fff700"
                      colspan="2"
                      text="AC2"
                      selected={selectedData?.owasScrRange === '2'}
                    />
                    <ColloredTd
                      color="#ffa600"
                      colspan="1"
                      text="AC3"
                      selected={selectedData?.owasScrRange === '3'}
                    />
                    <ColloredTd
                      color="#ffa600"
                      colspan="1"
                      text="AC4"
                      selected={selectedData?.owasScrRange === '4'}
                    />
                  </tr>
                  <tr>
                    <th className="bg3">RULA</th>
                    <ColloredTd
                      color="#28a745"
                      colspan="1"
                      text="1-2"
                      selected={selectedData?.rulaScrRange === '1'}
                    />
                    <ColloredTd
                      color="#fff700"
                      colspan="2"
                      text="3-4"
                      selected={selectedData?.rulaScrRange === '3'}
                    />
                    <ColloredTd
                      color="#ffa600"
                      colspan="2"
                      text="5이상"
                      selected={
                        selectedData?.rulaScrRange === '5' ||
                        selectedData?.rulaScrRange === '7'
                      }
                    />
                  </tr>
                  <tr>
                    <th className="bg3">REBA</th>
                    <ColloredTd
                      color="#28a745"
                      colspan="1"
                      text="1"
                      selected={selectedData?.rebaScrRange === '1'}
                    />
                    <ColloredTd
                      color="#fff700"
                      colspan="2"
                      text="2-7"
                      selected={
                        selectedData?.rebaScrRange === '2' ||
                        selectedData?.rebaScrRange === '4'
                      }
                    />
                    <ColloredTd
                      color="#ffa600"
                      colspan="2"
                      text="8이상"
                      selected={
                        selectedData?.rebaScrRange === '8' ||
                        selectedData?.rebaScrRange === '11'
                      }
                    />
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p className="tbl-msg tbl-msg--box">
            위험한 유해요인이 발견되지 않았습니다.
          </p>
        )}
      </div>
    </>
  );
};

export default ConsultVideoFrame;
